module.exports = __webpack_public_path__ + "img/protocol-approved.92da08a8.svg";